import moment from "moment";
import { APPLICATION_STATUS, SYNC_FIELDS_STATUS_DICT } from "constants/opekepe";

const PAYMENT_METHOD_BY_SOURCE = {
  cash: "cash",
  viva_rf: "rf",
  viva_checkout: "electronic",
};

export class MyFarmersDto {
  static fromApi(data) {
    return data.map((farmer) => {
      const registeredKydUser = !(
        Boolean(farmer?.user?.lastLogin) ||
        farmer?.user?.mobileVerified ||
        farmer.connectedToOpekepe ||
        farmer.syncedToOpekepe
      );
      let status = "registeredKydUser";
      if (farmer.syncedToOpekepe) {
        status = "syncedFields";
      } else if (farmer.connectedToOpekepe) {
        status = "opekepe";
      } else if (farmer?.user?.mobileVerified) {
        status = "otp";
      } else if (Boolean(farmer?.user?.lastLogin)) {
        status = "camvioConnection";
      }

      const latestApplication = farmer?.opekepeSyncStats?.[0];
      let applicationStatus = "";
      if (latestApplication?.applicationStatusCode in APPLICATION_STATUS) {
        applicationStatus =
          APPLICATION_STATUS[latestApplication.applicationStatusCode];
      }

      return {
        id: farmer?.user?.id,
        lastName: farmer?.user?.lastName || "",
        firstName: farmer?.user?.firstName || "",
        taxNumber: farmer?.user?.taxNumber || "",
        phone: farmer?.user?.phone || "",
        email: farmer?.user?.email || "",
        camvioConnection: Boolean(farmer?.user?.lastLogin),
        otp: farmer?.user?.mobileVerified,
        opekepe: farmer.connectedToOpekepe,
        syncedFields: farmer.syncedToOpekepe,
        registeredKydUser,
        status,
        opekepeApplications: farmer?.opekepeSyncStats?.map((app) => ({
          status: SYNC_FIELDS_STATUS_DICT[app?.syncStatus],
          totalFields: (app?.numSyncFields || 0) + (app?.numNewFields || 0),
          totalCrops: app?.numUniqueCrops || 0,
          year: app?.year,
          dateSynced: app?.updatedAt
            ? moment(app?.updatedAt).toISOString()
            : moment(app?.createdAt).toISOString(),
        })),
        availableSubscriptionYears: farmer?.opekepeSubscriptionYears || [],
        applicationStatus,
        documentCodes: latestApplication?.documentTypeCodesList || [],
        smartApp: latestApplication?.smartAgricultureToolCodeDisplay || "",
        amountOwed: farmer?.amountOwed ?? null,
        hasPaidSubscription: Boolean(farmer?.hasPaidSubscription),
        latestInvoiceId: farmer?.latestInvoiceId ?? null,
        pendingRfCode: farmer?.pendingRfCode ?? null,
        spdInvoice: farmer?.spdInvoice ?? null,
        paymentMethod: PAYMENT_METHOD_BY_SOURCE[farmer?.paymentSource] ?? null,
        cashReceivedAt: farmer?.cashReceivedAt ?? null,
        pendingCashOrder: farmer?.pendingCashOrder ?? null,
        totalOwnedAreaM2: farmer?.totalOwnedAreaM2 ?? 0,
        billableStremmata: farmer?.billableStremmata ?? 0,
        fieldsCount: farmer?.fieldsCount ?? 0,
      };
    });
  }
}
